function Footer() {
  return (
    <footer className='footer w-100 bg-primary'>
      <div className='d-none d-md-flex w-100 h-100 align-items-center text-white'>
        <div className='ms-4 me-2 me-lg-4' style={{ width: '180px' }}>
          <h6 className='fs-5'>Svenska Bilsportförbundet</h6>
        </div>
        <div className='d-flex flex-column justify-content-center ms-4 me-2 me-lg-4'>
          <h6 className='lh-1'>Organisationsnummer</h6>
          <span className='text-light' style={{ fontSize: '0.9rem' }}>
            802000-3425
          </span>
          <span className='opacity-0 ms-2' style={{ fontSize: '0.9rem' }}>
            802000-3425
          </span>
        </div>
        <div className='d-flex flex-column justify-content-center ms-4 me-2 me-lg-4'>
          <h6 className='lh-1'>Adress</h6>
          <span className='text-light' style={{ fontSize: '0.9rem' }}>
            Bergkällavägen 31A
          </span>
          <span className='text-light' style={{ fontSize: '0.9rem' }}>
            192 79 Sollentuna
          </span>
        </div>
        <div className='d-flex flex-column justify-content-center ms-4 me-2 me-lg-4'>
          <h6 className='lh-1'>Kontaktuppgifter</h6>
          <span className='text-light' style={{ fontSize: '0.9rem' }}>
            Telefon: +46 86 26 33 00
          </span>
          <span className='text-light' style={{ fontSize: '0.9rem' }}>
            E-post:{' '}
            <a
              className='link-info'
              href='mailto:mailbox@sbf.se'
              style={{ fontSize: '0.9rem' }}
            >
              mailbox@sbf.se
            </a>
          </span>
        </div>
      </div>
      <div className='d-flex flex-column d-md-none justify-content-center w-100 h-100 text-white'>
        <div className='d-flex ms-4'>
          <h6 className='fs-5'>Svenska Bilsportförbundet</h6>
        </div>
        <div className='d-flex ms-4 mt-2'>
          <h6>Organisationsnummer</h6>
          <span className='text-light ms-2' style={{ fontSize: '0.9rem' }}>
            802000-3425
          </span>
        </div>
        <div className='d-flex ms-4 mt-2'>
          <div className='d-flex flex-column'>
            <h6 className='lh-1'>Adress</h6>
            <span className='text-light' style={{ fontSize: '0.9rem' }}>
              Bergkällavägen 31A
            </span>
            <span className='text-light' style={{ fontSize: '0.9rem' }}>
              192 79 Sollentuna
            </span>
          </div>
          <div className='d-flex flex-column ms-4'>
            <h6 className='lh-1'>Kontaktuppgifter</h6>
            <span className='text-light' style={{ fontSize: '0.9rem' }}>
              Telefon: +46 86 26 33 00
            </span>
            <span className='text-light' style={{ fontSize: '0.9rem' }}>
              E-post:{' '}
              <a
                href='mailto:mailbox@sbf.se'
                className='link-info'
                style={{ fontSize: '0.9rem' }}
              >
                mailbox@sbf.se
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
